import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import AnimalDonation from '@/components/AnimalDonation'
import Nomad from '../components/Nomad.vue'
import store from '../store'
import Listing from '@/components/listing'
import {nginxTags} from '../assets/js/nginxTagsRedirection'
import getLastPage from '@/assets/js/getLastPage'
import LandingPage from '@/components/LandingPage'

const getSelectedCountry = localStorage.getItem('tss-v2__selectedCountryAddress')
const isSelectedCountryGlobal = getSelectedCountry ? parseInt(JSON.parse(getSelectedCountry).value.countryId) !== 99 : false

Vue.use(Router)

var $ = require('jquery')
window.jQuery = $

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: LandingPage
    },
    {
      path: '/animal-donation',
      name: 'AnimalDonation',
      component: AnimalDonation
    },
    {
      path: '/nomad',
      name: 'Nomad',
      component: Nomad
    },
    {
      path: '/men',
      name: 'home',
      component: Home
    },
    {
      path: '/women',
      name: 'home',
      component: Home
    },
    {
      path: '/kids',
      name: 'home',
      component: Home
    },
    {
      path: '/winter-collection',
      name: 'WinterCollection',
      component: () => import(/* webpackChunkName: "WinterCollection" */ '@/components/winterCollection')
    },
    {
      path: '/stores-near-me',
      name: 'StoreLocator',
      component: () => import(/* webpackChunkName: "StoreLocator" */ '@/components/StoreLocator/storeLocator'),
      beforeEnter: (to, from, next) => {
        if (isSelectedCountryGlobal) {
          next({
            path: '/'
          })
        } else {
          next()
        }
      }
    },
    {
      path: '/year-in-review',
      name: 'YearInReview',
      component: () => import(/* webpackChunkName: "YearInReview" */ '@/components/yearInReview')
    },
    {
      path: '/getnotified',
      name: 'GetNotified',
      component: () => import(/* webpackChunkName: "YearInReview" */ '@/components/GetNotified')
    },
    {
      path: '/orders/details/:id',
      name: 'Order Details',
      component: () => import(/* webpackChunkName: "Order Details" */ '@/components/common/orderDetails'),
      meta: { requiresAuth: true }
    },
    {path: '/explore/jumpsuits', redirect: '/men/jumpsuits'},
    {path: '/explore/unisex-jumpsuits', redirect: '/women/unisex-jumpsuits'},
    {path: '/artists/clearance-sale', redirect: '/tags/clearance-sale'},
    {path: '/explore/mobile-covers', redirect: '/mobile-covers'},
    {path: '/explore/tank-tops', redirect: '/men/tank-tops-and-vests'},
    {path: '/explore/vests', redirect: '/men/tank-tops-and-vests'},
    {path: '/explore/toys-and-video-games', redirect: 'explore/toys-and-games'},
    {path: '/artists/rosesarered', redirect: 'rosesarered'},
    {path: '/kkr', redirect: '/artists/kolkata-knight-riders'},
    {path: '/rr', redirect: '/artists/official-merchandise-rajasthan-royals'},
    {path: '/mi', redirect: '/artists/mumbai-indians'},
    {path: '/csk', redirect: '/artists/chennai-super-kings'},
    {path: '/wwe/explore/mobile-covers', redirect: '/mobile-covers'},
    {path: '/listing/shop/mobile-covers', redirect: '/mobile-covers'},
    {path: '/artists/kfc', redirect: '/artists/official-merchandise-kfc'},
    {path: '/faq/returnexchange', redirect: '/faqs'},
    {path: '/artists/ludoking', redirect: '/men/t-shirts'},
    // {path: '/feed-the-soul', redirect: '/'},
    {path: '/the-responsible-mask', redirect: '/explore/cotton-masks'},
    {path: '/product/superman-logo-solar activated-full-sleeve-tshirt', redirect: '/men/full-sleeve-tshirts'},
    {path: '/product/harry-potter-hogwarts-alumni-tshirt', redirect: '/men/full-sleeve-tshirts'},
    {path: '/product/solids-red-melange-tshirt-dress', redirect: '/women/t-shirt-dresses'},
    {path: '/product/spiderman-face-tshirt-dress', redirect: '/women/t-shirt-dresses'},
    {path: '/product/boats-and-waves-tshirt-dress', redirect: '/women/t-shirt-dresses'},
    {path: '/product/solids-maroon-melange-full-sleeves-tshirt-dress', redirect: '/women/t-shirt-dresses'},
    {path: '/product/slay-tshirt-dress', redirect: '/women/t-shirt-dresses'},
    {path: '/product/espresso-yourself-tshirt-dress', redirect: '/women/t-shirt-dresses'},
    {path: '/product/feminist-symbol-tshirt-dress', redirect: '/women/t-shirt-dresses'},
    {path: '/product/i-didnt-now-tshirt-dress', redirect: '/women/t-shirt-dresses'},
    {path: '/product/infinity-war-hulk-buster', redirect: '/women/t-shirt-dresses'},
    {path: '/product/test-23438', redirect: '/women/t-shirt-dresses'},
    {path: '/product/dinosaur-pattern-tshirt-dress', redirect: '/women/t-shirt-dresses'},
    {path: '/product/gfg-i-love-crossing', redirect: '/men/t-shirts'},
    {path: '/product/resanskrit_ahamasmi_yodha_tshirt', redirect: '/men/t-shirts'},
    {path: '/product/gfg-horizontal-stripes-polo-white-red-maroon-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/harry-potter-ravenclaw-sigil-tshirt', redirect: '/men/t-shirts'},
    // {path: '/product/marijuana-pattern-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/harry-potter-master-of-death-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/wwe-braun-strowman-get-these-hands-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/solids-wine-melange-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/tbbt-bazinga-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/black-panther-panther-quest-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/infinity-war-captain-america-super-soilder-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/magneto-join-the-revolution-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/cyclops-optic-blast-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/friends-doodle-tshirt-new', redirect: '/men/t-shirts'},
    {path: '/product/kxip-gayle-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/nishant-tanwar-gaadi-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/nishant-tanwar-maha-cool-Black-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/nishant-tanwar-dilli-se-hoon-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/wwe-wrestlemania-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/wwe-wrestlemania-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/running-late-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/roses-are-red-your-sexist-jokes-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/roses-are-red-guys-being-hated-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/roses-are-red-tired-of-living-them-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/roses-are-red-while-i-bleed-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/roses-are-red-you-need-a-shrink-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/roses-are-red-what-we-dig-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/roses-are-red-not-your-play-thing-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/roses-are-red-just-a-tool-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/roses-are-red-me-and-you-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/roses-are-red-its-2018-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/roses-are-red-does-not-concern-you-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/roses-are-red-yes-means-yes-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/day-job-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/ankur-and-ghalat-family-side-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/shit-i-give-not-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/punisher-logo-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/superman-symbol-of-hope-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/superman-its-only-a-bird-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/sorry-ladies-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/monopoly-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/batman-bat-signal-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/zakir-khan-sakht-squad-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/wwe-authentic-paige-the-scream-is-back-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/wwe-authentic-the-shield-hounds-unite-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/rahul-subramanian-not-a-gandhi-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/rahul-subramanian-kal-main-udega-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/rahul-subramanian-chembur-of-secrets-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/aib-premium-dhoka-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/aib-pyaar-ek-dhoka-hai-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/aib-pyaar-ek-dhoka-hai-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/black-panther-challenger-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/zakir-khan-mushkil-waqth-package-sakht', redirect: '/men/t-shirts'},
    {path: '/product/sass-and-badass-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/wolverine-logan-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/star-wars-born-rebel-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/aiyaary-surveillance-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/aiyaary-encrypted-navy-blue-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/aiyaary-encrypted-black-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/aiyaary-angel-and-devil-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/aiyaary-surveillance-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/aiyaary-encrypted-navy-blue-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/aiyaary-encrypted-black-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/aiyaary-angel-and-devil-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/friends-joey-black-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/wanderlust-dark-blue-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/dexter-talk-nerdy-grey-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/looney-tunes-whats-up-doc--dark-blue-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/aib-meme-rewind-black-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/aib-meme-rewind-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/fundamental-rights-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/tripping-on-space-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/harry-potter-prophecy-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/scooby-doo-scoob-dogg-and-shagster-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/aib-why-so-overused-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/train-your-human-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/harry-potter-hagrid-and-friends-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/harry-potter-triwizard-champion-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/star-wars-kylo-ren-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/shift-happens-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/wwe-live-india-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/zodiac-taurus-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/harry-potter-hufflepuff-sigil-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/motivational-speaker-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/harry-potter-elder-wand-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/batman-batsuit-blueprint-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/batman-dark-knight-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/beardo-im-sexy-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/beardo-such-a-beardo-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/beardo-i-like-big-beards-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/harry-potter-marauders-map-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/aib-meh-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/unofficial-bombay-high-court-totally-judging-you', redirect: '/men/t-shirts'},
    {path: '/product/unofficial-bombay-high-court-2-official-4-you', redirect: '/men/t-shirts'},
    {path: '/product/life-is-brewtiful-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/pokemon-snorlax-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/pokemon-charmander-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/harry-potter-avada-kedavra-glow-in-the-dark-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/test-23437', redirect: '/men/t-shirts'},
    {path: '/product/scooby-doo-mystery-machine-adventures-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/pokemon-blastoise-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/joker-don\'t-play-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/joker-don\'t-play-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/test1', redirect: '/men/t-shirts'},
    {path: '/product/test-23435', redirect: '/men/t-shirts'},
    {path: '/product/chemical-engineer-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/90s-gamer-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/authentic-wwe-samoa-joe-the-right-hand-of-destruction-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/authentic-wwe-shinsuke-nakamura-the-artist-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/flintstones-bam-bam-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/batman-classic-logo-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/dexter-stay-out-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/batman-classic-logo-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/dexter-stay-out-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/batman-classic-logo-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/dexter-stay-out-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/dexter-omelette-du-fromage-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/dexter-dee-dee-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/who-came-first-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/circuified-engineer-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/official-wwe-dx-army-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/think-bigger-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/flintstones-dino-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/nit-logo-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/yoga-pulp-lit-in-litchi-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/restless-under-construction-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/restless-satisfaction-is-failure-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/restless-think-less-do-more-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/sniff-naak-me-dum-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/sniff-danger-ki-smell-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/the-flash-bolt-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/life-of-an-engineer-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/pocket-tees-patrick-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/spongebob-imagination-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/amit-tandon-facebook-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/tmnt-the-turtles-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/tmnt-leonardo-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/food-sharing-dilemma-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/electrical-engineer-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/scooby-doo-where-are-you-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/aaiii-scream-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/scooby-doo-meddling-kids-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/tmnt-shredder-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/civil-engineer-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/mechanical-engineer-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/spider-man-homecoming-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/not-the-life-i-ordered-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/spider-man-friendly-neighbourhood-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/coffee-power-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/authentic-wwe-the-hardy-boyz-reborn-by-fate-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/mad-calcutta-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/mad-hatted-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/mad-stage-pe-mil-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/spongebob-bros-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/iron-man-the-invincible-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/bank-chor-logo-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/bank-chor-caricature-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/bank-chor-aukaat-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/authentic-wwe-dean-ambrose-this-lunatic-runs-the-asylum-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/spongebob-stay-glassy-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/authentic-wwe-jinder-mahal-modern-day-maharaja-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/authentic-wwe-the-rock-bringing-it-for-20-years-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/wwe-the-rock-bringing-it-for-20-years-t-shirt', redirect: '/men/t-shirts'},
    {path: '/product/powerdrift-brotherhood-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/powerdrift-grenadier-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/powerdrift-troopers-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/powerdrift-indian-motorhead-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/gotg-volume-2-star-lord-costume-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/gotg-volume-2-limited-edition-glow-in-dark-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/gotg-volume-2-the-guardians-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/authentic-wwe-chris-jericho-you-just-made-the-list-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/aib-manauj-womens-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/gamer-i-kill-noobs-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/aib-tragedy-mein-comedy', redirect: '/men/t-shirts'},
    {path: '/product/aib-kaafi-cotton-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/sharma-ji-ka-beta-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/caffeine-stream-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/hulk-face-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/kxip-virender-sehwag-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/authentic-wwe-triple-h-all-hope-is-gone-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/kkr-fan-combo-1', redirect: '/men/t-shirts'},
    {path: '/product/kkr-fan-tshirts-combo', redirect: '/men/t-shirts'},
    {path: '/product/kkr-fan-tshirts-combo', redirect: '/men/t-shirts'},
    {path: '/product/kkr-official-polo-tshirts', redirect: '/men/t-shirts'},
    {path: '/product/kkr-official-polo-tshirts', redirect: '/men/t-shirts'},
    {path: '/product/kkr-fan-tshirts-combo', redirect: '/men/t-shirts'},
    {path: '/product/kkr-official-polo-tshirts', redirect: '/men/t-shirts'},
    {path: '/product/kkr-fan-tshirts-combo', redirect: '/men/t-shirts'},
    {path: '/product/kkr-official-polo-tshirts', redirect: '/men/t-shirts'},
    {path: '/product/kkr-replica-jerseys', redirect: '/men/t-shirts'},
    {path: '/product/kxip-hashim-amla-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/kxip-glenn-maxwell-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/kxip-david-miller-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/kxip-logo-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/kings-xi-mighty-hash-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/kings-xi-mad-max-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/kings-xi-killer-miller-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/kings-xi-logo-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/imagination-logic-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/pokemon-pikachu-face-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/spoiler-alert-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/old-school-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/kkr-vintage-logo-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/kkr-korbo-lorbo-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/kkr-eden-gardens-white-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/kkr-ami-kkr-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/harry-potter-prisoner-of-azkaban-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/wwe-brock-lesnar-suplex-city-authentic-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/wwe-seth-freakin-rollins-authentic-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/wwe-roman-reigns-from-ashes-to-empire-authentic-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/wwe-randy-orton-outta-nowhere-authentic -tshirt', redirect: '/men/t-shirts'},
    {path: '/product/wwe-john-cena-respect-earn-it-authentic -tshirt', redirect: '/men/t-shirts'},
    {path: '/product/wwe-kevin-owens-the-kevin-owens-show-authentic-t-Shirt', redirect: '/men/t-shirts'},
    {path: '/product/wwe-chris-jericho-you-just-made-the-list-vintage-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/wwe-triple-h-all-hope-is-gone-authentic -tshirt', redirect: '/men/t-shirts'},
    {path: '/product/wwe-goldberg-devastation-continues-authentic -tshirt', redirect: '/men/t-shirts'},
    {path: '/product/wwe-finn-b', redirect: '/men/t-shirts'},
    {path: '/product/wwe-enzo-and-big-cass-certified-g-authentic -tshirt', redirect: '/men/t-shirts'},
    {path: '/product/wwe-bray-wyatt-illuminate-oblivion-authentic-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/wwe-the-rock-brahma-bull-authentic-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/wwe-dean-ambrose-this-lunatic-runs-the-asylum-authentic-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/wwe-aj-styles-they-don', redirect: '/men/t-shirts'},
    {path: '/product/bmp-french-horn-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/bmp-guitar-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/pokemon-rattata-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/fitternity-meet-you-at-the-bar-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/fitternity-life-behind-bars-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/fitternity-avocardio-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/fitternity-musclein-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/star-wars-master-yoda-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/hibernation-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/star-wars-r2d2-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/nobody-exists-on-purpose-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/never-judge-a-book-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/butter-chicken-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/aib-che-gormint-red-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/star-wars-storm-trooper-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/gotg-the-team-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/punisher-war-zone-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/lotr-dwarves-wizards-elves-and-hobbits-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/free-shrugs-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/star-wars-boba-fett-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/wwe-balor-club-grey-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/official-wwe-brock-lesnar-graphic-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/stud-muffin-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/flintstones-ready-to-rubble-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/aib-che-gormint-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/captain-america-the-first-avenger-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/otaku-and-proud-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/the-upside-down-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/celestial-teapot-logo-light-grey-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/celestial-teapot-logo-navy-blue-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/bad-decisions-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/pocket-tees-spiderman-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/harry-potter-marauders-maroon-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/friends-bamboozled-t-shirt', redirect: '/men/t-shirts'},
    {path: '/product/taz-party-animal-t-shirt', redirect: '/men/t-shirts'},
    {path: '/product/star-wars-retro-falcon-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/star-wars-resistance-is-futile-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/star-wars-darth-maul-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/the-bastard-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/flintstones-runs-on-feet-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/flintstones-legends-of-rock-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/game-of-potatoes-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/mumbai-home-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/harry-potter-the-boy-who-lived-t-shirt-india', redirect: '/men/t-shirts'},
    {path: '/product/official-wwe-randy-orton-rko-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/nicholson-logo-white-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/worlds-greatest-human-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/party-without-alcohol-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/doctor-strange-logo-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/joker-watch-the-world-burn-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/pi-t-shirt', redirect: '/men/t-shirts'},
    {path: '/product/sanam-justice-hope', redirect: '/men/t-shirts'},
    {path: '/product/pokemon-pikachu-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/pokemon-catch-em-all-t-shirt', redirect: '/men/t-shirts'},
    {path: '/product/pokemon-trainer-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/pokemon-pokeball-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/sanam-yellow-t-shirt', redirect: '/men/t-shirts'},
    {path: '/product/sanam-millionare-t-shirt-india', redirect: '/men/t-shirts'},
    {path: '/product/sanam-instruments-t-shirt-india', redirect: '/men/t-shirts'},
    {path: '/product/sanam-fab-four-t-shirt', redirect: '/men/t-shirts'},
    {path: '/product/sanam-logo-black-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/duplicate-sanam-logo-black-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/ninja-rule-no-1-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/sanam-logo-millonare-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/sanam-logo-black-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/more-than-a-game-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/scooby-doo-mystery-machine-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/official-wwe-goldberg-youre-next-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/tbbt-friendship-algorithm-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/tbbt-knock-knock-penny-t-shirt', redirect: '/men/t-shirts'},
    {path: '/product/science-doesnt-give-a-shit-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/science-doesnt-give-a-shit-t-shirt', redirect: '/men/t-shirts'},
    {path: '/product/doctor-strange-stephen-strange-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/mortal-kombat-official-merchandise-sub-zero-t-shirt', redirect: '/men/t-shirts'},
    {path: '/product/mortal-kombat-scorpion-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/mortal-kombat-logo-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/death-note-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/wwe-seth-rollins-t-shirt', redirect: '/men/t-shirts'},
    {path: '/product/rock-on-2-udja-re-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/rock-on-2-eat-sleep-jaago-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/rock-on-2-original-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/rock-on-original-t-shirt', redirect: '/men/t-shirts'},
    {path: '/product/rock-on-2-spoof-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/harry-potter-last-paragraph-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/rock-on-2-jaago-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/kru172-chandigarh-bleach-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/kru172-chandigarh-navy-blue-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/harry-potter-hufflepuff-t-shirt-india', redirect: '/men/t-shirts'},
    {path: '/product/wwe-a-j-styles--t-shirt-india', redirect: '/men/t-shirts'},
    {path: '/product/harry-potter-muggles-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/fire-blood-t-shirt', redirect: '/men/t-shirts'},
    {path: '/product/bmp-let-go-guitar-t-shirt', redirect: '/men/t-shirts'},
    {path: '/product/bmp-let-go-horn-t-shirt', redirect: '/men/t-shirts'},
    {path: '/product/seal-of-approval-t-shirt', redirect: '/men/t-shirts'},
    {path: '/product/fries-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/official-wwe-kevin-owens-ko-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/being-indian-good-vibes-only-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/express-delivery-t-shirt', redirect: '/men/t-shirts'},
    {path: '/product/being-indian-just-chilling-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/kenny-sebastian-chai-time-purple-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/marvel-official-merchandise-captain-america-line-of-duty-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/foodie-t-shirt', redirect: '/men/t-shirts'},
    {path: '/product/cutting-chai-t-shirt', redirect: '/men/t-shirts'},
    {path: '/product/gully-cricket-t-shirt', redirect: '/men/t-shirts'},
    {path: '/product/just-one-more-episode-t-shirt', redirect: '/men/t-shirts'},
    {path: '/product/star-wars-darth-maul', redirect: '/men/t-shirts'},
    {path: '/product/star-wars-boba-fett-t-shirt', redirect: '/men/t-shirts'},
    {path: '/product/star-wars-jedi-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/i-didnt-know-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/bengaluru-bulls-kids-t-shirt', redirect: '/men/t-shirts'},
    {path: '/product/tixdo-i-love-cinema-black-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/tixdo-i-love-cinema-blue-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/tixdo-i-love-cinema-white-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/tixdo-logo-black-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/tixdo-logo-blue-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/tixdo-logo-white-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/marvel-official-merchandise-groot-logo-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/superman-symbol-of-hope-t-shirt', redirect: '/men/t-shirts'},
    {path: '/product/cat-world-t-shirt', redirect: '/men/t-shirts'},
    {path: '/product/marvel-official-merchandise-avengers-team-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/marvel-official-merchandise-spiderman-the-next-avenger-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/marvel-official-merchandise-avengers-logo-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/hulk-incredible-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/marvel-official-merchandise-avengers-hulk-smash-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/ganesh-talkies-logo-white-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/the-flash-power-t-shirt', redirect: '/men/t-shirts'},
    {path: '/product/kru172-logo-black-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/kru172-logo-white-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/friends-doodle-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/ganesh-talkies-logo-black-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/harry-potter-official-merchandise-dumbledores-army-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/bb-logo-t-shirt', redirect: '/men/t-shirts'},
    {path: '/product/bengaluru-bulls-kabaddi-evolution-t-shirt', redirect: '/men/t-shirts'},
    {path: '/product/wwe-hustle-loyalty-respect-t-shirt', redirect: '/men/t-shirts'},
    {path: '/product/excuses-dont-burn-calories-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/pizza-opinion-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/looney-tunes-say-your-prayers-t-shirt', redirect: '/men/t-shirts'},
    {path: '/product/looney-tunes-thats-all-folks-t-shirt', redirect: '/men/t-shirts'},
    {path: '/product/pretend-to-work-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/lotr-my-precious-t-shirt', redirect: '/men/t-shirts'},
    {path: '/product/justice-league-t-shirt', redirect: '/men/t-shirts'},
    {path: '/product/harry-potter-death-eater-glow-in-the-dark-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/joker-why-so-serious-tshirt-india', redirect: '/men/t-shirts'},
    {path: '/product/batman-vs-superman-t-shirt-india', redirect: '/men/t-shirts'},
    {path: '/product/superman-logo-t-shirt-india', redirect: '/men/t-shirts'},
    {path: '/product/flash-logo-t-shirt-india', redirect: '/men/t-shirts'},
    {path: '/product/green-lantern-t-shirt-india', redirect: '/men/t-shirts'},
    {path: '/product/batman-logo-t-shirt-india', redirect: '/men/t-shirts'},
    {path: '/product/superman-its-a-bird-t-shirt-india', redirect: '/men/t-shirts'},
    {path: '/product/the-flash-t-shirt-india', redirect: '/men/t-shirts'},
    {path: '/product/dare-to-fail-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/90s-kid-T-shirt', redirect: '/men/t-shirts'},
    {path: '/product/harry-potter-official-merchandise-expecto-patronum-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/truly-madly-my-ex-t-shirt', redirect: '/men/t-shirts'},
    {path: '/product/truly-madly-gym-t-shirt', redirect: '/men/t-shirts'},
    {path: '/product/truly-madly-i-dont-have-shirt', redirect: '/men/t-shirts'},
    {path: '/product/harry-potter-official-merchandise-snape-always-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/lotr-you-shall-not-pass-t-shirt', redirect: '/men/t-shirts'},
    {path: '/product/talk-nerdy-to-me-t-shirt', redirect: '/men/t-shirts'},
    {path: '/product/wwe-sting-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/harry-potter-official-merchandise-sirius-black-wanted-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/do-epic-shit-t-shirt', redirect: '/men/t-shirts'},
    {path: '/product/just-five-more-minutes-t-shirt', redirect: '/men/t-shirts'},
    {path: '/product/official-wwe-dean-ambrose-da-unstable-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/official-wwe-dx-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/official-wwe-undertaker-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/bob-marley-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/official-wwe-yes-yes-yes-t-shirt', redirect: '/men/t-shirts'},
    {path: '/product/harry-potter-official-merchandise-weazleys-wizard-wheezes-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/official-wwe-just-bring-it-t-shirt', redirect: '/men/t-shirts'},
    {path: '/product/official-lotr-minas-tirth', redirect: '/men/t-shirts'},
    {path: '/product/official-lotr-speak-friend-and-enter-gates-of-durin-t-shirt', redirect: '/men/t-shirts'},
    {path: '/product/official-lotr-fellowship-of-the-ring-t-shirt', redirect: '/men/t-shirts'},
    {path: '/product/lotr-sauron-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/i-dont-do-mornings-rooster-edition-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/the-big-bang-theory-official-merchandise-thats-my-spot-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/harry-potter-deathly-hallows-tshirt', redirect: '/men/t-shirts'},
    // {path: '/product/harry-potter-slytherin-sigil-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/official-tbbt-sheldon-evolution', redirect: '/men/t-shirts'},
    {path: '/product/tbbt-doodle-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/how-i-met-your-mother-slap-bet-commissioner-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/mumbai-kaleidoscope-psychedelic-t-shirt', redirect: '/men/t-shirts'},
    {path: '/product/king-of-pop-michael-jackson-card-design-t-shirt', redirect: '/men/t-shirts'},
    {path: '/product/wwe-glow-in-dark-t-shirt', redirect: '/men/t-shirts'},
    {path: '/product/official-wwe-roman-reigns-hit-hard-hit-often-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/cool-zodiac-t-shirts-gemini', redirect: '/men/t-shirts'},
    {path: '/product/supernatural-tv-show-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/official-wwe-steve-austin-stone-cold-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/official-wwe-hell-yeah-t-shirt', redirect: '/men/t-shirts'},
    {path: '/product/official-wwe-seth-rollins-t-shirt', redirect: '/men/t-shirts'},
    {path: '/product/daniel-fernandes-just-because-womens-fit-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/daniel-fernandes-pravin-tambe-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/wonka-bar-willy-wonka-t-shirt', redirect: '/men/t-shirts'},
    {path: '/product/fight-the-dead-fear-the-living-walking-dead-t-shirt', redirect: '/men/t-shirts'},
    {path: '/product/reggae-rajahs-logo-white-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/reggae-rajahs-logo-black-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/zodiac-series-scorpio-t-shirt', redirect: '/men/t-shirts'},
    {path: '/product/retro-gamer-gaming-geeky-t-shirt', redirect: '/men/t-shirts'},
    {path: '/product/rajma-man-food-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/super-saiyan-tv-t-shirts', redirect: '/men/t-shirts'},
    {path: '/product/interstellar-minimalistic-time-t-shirt', redirect: '/men/t-shirts'},
    {path: '/product/the-big-bang-theory-official-merchandise-friendship-algorithm-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/tssc-logo-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/reggae-rajahs-rajah-army-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/plata-o-plomo-t-shirt', redirect: '/men/t-shirts'},
    {path: '/product/nicholson-tank-tops-pink', redirect: '/men/t-shirts'},
    {path: '/product/nicholson-vests-black-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/nicholson-logo-black-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/gamblers-anonymous-addiction-t-shirt', redirect: '/men/t-shirts'},
    {path: '/product/7-deadly-sins-pride-t-shirt', redirect: '/men/t-shirts'},
    {path: '/product/herbivore-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/aaila-ooimaa-funny-t-shirt', redirect: '/men/t-shirts'},
    {path: '/product/7-deadly-sins-sloth-t-shirts', redirect: '/men/t-shirts'},
    {path: '/product/7-deadly-sins-wrath-t-shirt', redirect: '/men/t-shirts'},
    {path: '/product/moonwalker-t-shirt', redirect: '/men/t-shirts'},
    {path: '/product/wsom-hoodies-bacardi-nh7-weekender-official-wsom-hoodies', redirect: '/men/t-shirts'},
    {path: '/product/line-up-pune-bacardi-nh7-weekender-official-line-up-t-shirts', redirect: '/men/t-shirts'},
    {path: '/product/line-up-bangalore-bacardi-nh7-weekender-official-line-up-t-shirts', redirect: '/men/t-shirts'},
    {path: '/product/nh7-line-up-delhi-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/the-big-bang-theory-official-merchandise-logo-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/bruce-lee-formless-t-shirt', redirect: '/men/t-shirts'},
    {path: '/product/graham-bell-who-dis-t-shirt', redirect: '/men/t-shirts'},
    {path: '/product/strong-beer-weak-men-funny-t-shirt', redirect: '/men/t-shirts'},
    {path: '/product/will-save-the-world-for-food-recession-strikes-t-shirt', redirect: '/men/t-shirts'},
    {path: '/product/tbbt-theme-song-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/the-big-bang-theory-official-merchandise-rock-paper-scissor-lizard-spock-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/tbbt-dr-dr-dr-mr-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/friends-turkey-head-official-merchandise-tshirts', redirect: '/men/t-shirts'},
    {path: '/product/were-all-alright-70s-show-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/zodiac-series-leo', redirect: '/men/t-shirts'},
    {path: '/product/zodiac-series-sagittarius', redirect: '/men/t-shirts'},
    {path: '/product/zodiac-series-taurus-ships-12th-nov', redirect: '/men/t-shirts'},
    {path: '/product/zodiac-series-aries-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/everybody-lies-dr-house-tv-show', redirect: '/men/t-shirts'},
    {path: '/product/somebody-stop-me-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/nh7-line-up-kolkata-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/joker-two-faced-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/sickflip-logo-white-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/sickflip-logo-black-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/ankur-and-ghalat-family-ghalat-family-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/f16s-triggerpunkte-bleached-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/f16s-triggerpunkte-black-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/the-stag-glow-in-dark-t-shirt', redirect: '/men/t-shirts'},
    {path: '/product/the-big-bang-theory-official-merchandise-schrodingers-cat-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/character-3-bacardi-nh7-weekender-tshirts', redirect: '/men/t-shirts'},
    {path: '/product/character-2-bacardi-nh7-weekender-tshirts', redirect: '/men/t-shirts'},
    {path: '/product/character-1-bacardi-nh7-weekender-tshirts', redirect: '/men/t-shirts'},
    {path: '/product/wsom-navy blue-bacardi-nh7-weekender-tshirts', redirect: '/men/t-shirts'},
    {path: '/product/wsom-bacardi-nh7-weekender-tshirts', redirect: '/men/t-shirts'},
    {path: '/product/bacardi-nh7-weekender-line-up-shillong-tshirts', redirect: '/men/t-shirts'},
    {path: '/product/funny-hungry-t-shirt-online', redirect: '/men/t-shirts'},
    {path: '/product/fast-bikes-gamer-t-shirt', redirect: '/men/t-shirts'},
    {path: '/product/courage-vintage-cartoons-t-shirt', redirect: '/men/t-shirts'},
    {path: '/product/the-resistance-down-with-the-capitol-t-shirt', redirect: '/men/t-shirts'},
    {path: '/product/the-king-elvis-t-shirt', redirect: '/men/t-shirts'},
    {path: '/product/friday-weekend-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/stone-paper-scissor-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/gurbax-boom-shankar-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/love-dont-pay-the-bills-buy-funny-T-shirts', redirect: '/men/t-shirts'},
    {path: '/product/campion-hoodie-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/highly-functioning-sociopath-t-shirt-online', redirect: '/men/t-shirts'},
    {path: '/product/to-beer-t-shirt', redirect: '/men/t-shirts'},
    {path: '/product/issac-newton-apple-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/dress-for-the-job-buy-funny-t-shirts-india', redirect: '/men/t-shirts'},
    {path: '/product/one-last-ride-ships-fast-and-the-furious-t-shirts-india', redirect: '/men/t-shirts'},
    {path: '/product/power-level-9000-goku-t-shirts-india', redirect: '/men/t-shirts'},
    {path: '/product/100-shots-alcohol-t-shirts-online', redirect: '/men/t-shirts'},
    {path: '/product/grammar-nazi-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/sng-gore-gote-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/the-wall-t-shirt-rahul-dravid', redirect: '/men/t-shirts'},
    {path: '/product/they-killed-kenny-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/swami-g-merch-chillum-yellow', redirect: '/men/t-shirts'},
    {path: '/product/swami-g-merch-chillum-green', redirect: '/men/t-shirts'},
    {path: '/product/nirvana-swamig-merch-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/wanderlust-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/mushroom-kingdom-game-buy-t-shirts-india', redirect: '/men/t-shirts'},
    {path: '/product/the-tardis-doctor-who-t-shirts-india', redirect: '/men/t-shirts'},
    {path: '/product/hunting-season-bugs-bunny-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/shakespeare-tshirt-india', redirect: '/men/t-shirts'},
    {path: '/product/Jon-snow-lord-commander-game-of-thrones-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/we-are-all-mad-here-tshirt-india', redirect: '/men/t-shirts'},
    {path: '/product/pmr-kaategi-kya-womens-fit-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/pug-life-t-shirts-online-india', redirect: '/men/t-shirts'},
    {path: '/product/giggity-goo-t-shirt', redirect: '/men/t-shirts'},
    {path: '/product/the-one-matrix-t-shirts-india', redirect: '/men/t-shirts'},
    {path: '/product/stop-wars-star-wars-tshirt-india', redirect: '/men/t-shirts'},
    {path: '/product/dont-like-people-t-shirt', redirect: '/men/t-shirts'},
    {path: '/product/wizard-gandalf-t-shirt-online', redirect: '/men/t-shirts'},
    {path: '/product/scooby-doo-mystery-solved-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/aib-certified-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/aib-your-baby-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/aib-sarkar-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/grammar-for-dummies-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/under-the-sea-cartoon-t-shirts', redirect: '/men/t-shirts'},
    {path: '/product/marauders-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/bengal-warriors-logo-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/desi-thug-life-posteries-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/secret-ingredient-kung-fu-panda', redirect: '/men/t-shirts'},
    {path: '/product/fight-club-movie-tshirt-india', redirect: '/men/t-shirts'},
    {path: '/product/ninja-funny-tshirt-india', redirect: '/men/t-shirts'},
    {path: '/product/best-times-alcohol-drinking-t-shirt-india', redirect: '/men/t-shirts'},
    {path: '/product/pmr-vitamin-sex-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/pmr-bulla-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/pmr-kaategi-kya-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/pmr-haseen-dard-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/Corporate-slave-dobby-t-shirts-india', redirect: '/men/t-shirts'},
    {path: '/product/Tea-Rex-Funny-T-Shirts-India', redirect: '/men/t-shirts'},
    {path: '/product/beta-tshirts-india', redirect: '/men/t-shirts'},
    {path: '/product/say-hello-scarface-movie-t-shirts-india', redirect: '/men/t-shirts'},
    {path: '/product/schrute-farms-t-shirts-india', redirect: '/men/t-shirts'},
    {path: '/product/fedex-buy-sports-t-shirts-online-india', redirect: '/men/t-shirts'},
    {path: '/product/one-man-army-rambo-movie-t-shirts', redirect: '/men/t-shirts'},
    {path: '/product/kabira-speaking-bollywood-T-shirts', redirect: '/men/t-shirts'},
    {path: '/product/the-God-Father-Spoof-T-shirt-India', redirect: '/men/t-shirts'},
    {path: '/product/old-school-gamer-t-shirts', redirect: '/men/t-shirts'},
    {path: '/product/Spinach-Cartoon-T-Shirts-India', redirect: '/men/t-shirts'},
    {path: '/product/Superhero-spoof-t-shirt-the-souled-store', redirect: '/men/t-shirts'},
    {path: '/product/your-chin-official-merchandise', redirect: '/men/t-shirts'},
    {path: '/product/campion-polo-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/the-north-remembers-Game-of-Thrones-T-Shirts-India', redirect: '/men/t-shirts'},
    {path: '/product/modern-family-phils-t-shirt-india', redirect: '/men/t-shirts'},
    {path: '/product/muhammad-ali-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/suits-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/harry-potter-swagrid-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/Carpe-Diem-T-Shirts-India', redirect: '/men/t-shirts'},
    {path: '/product/Steve-Jobs-Inspirational-T-Shirts-India', redirect: '/men/t-shirts'},
    {path: '/product/Calvin-and-Hobes-T-Shirts-India', redirect: '/men/t-shirts'},
    {path: '/product/scribe-cops-cops-tshirt-india', redirect: '/men/t-shirts'},
    {path: '/product/indus-creed-thief-tshirt-india', redirect: '/men/t-shirts'},
    {path: '/product/Walking-dead-zombie-t-shirts-india', redirect: '/men/t-shirts'},
    {path: '/product/harry-potter-sorted-bleached-t-shirt', redirect: '/men/t-shirts'},
    {path: '/product/this-is-sparta-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/poker-fold-laundry-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/mumbai-doodle-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/old-school-monopoly-t-shirts', redirect: '/men/t-shirts'},
    {path: '/product/Imagine-john-lennon-t-shirt', redirect: '/men/t-shirts'},
    {path: '/product/intellectual-badass-funny-t-shirt', redirect: '/men/t-shirts'},
    {path: '/product/hare-&-tortoise-funny-t-shirt', redirect: '/men/t-shirts'},
    {path: '/product/hakuna-Matata-T-Shirts-india', redirect: '/men/t-shirts'},
    {path: '/product/gutslit-maze-of-entrails-indian-rock-bands-t-shirts', redirect: '/men/t-shirts'},
    {path: '/product/gutslit-skewered-in-the-sewer-thirt-india', redirect: '/men/t-shirts'},
    {path: '/product/sorry-ladies-nights-watch-tshirts', redirect: '/men/t-shirts'},
    {path: '/product/funny-videogames-mario-t-shirt-india', redirect: '/men/t-shirts'},
    {path: '/product/gabbar-sholay-t-shirts-india', redirect: '/men/t-shirts'},
    {path: '/product/desi-tharra-spoof-t-shirts-India', redirect: '/men/t-shirts'},
    {path: '/product/Funny-minion-T-Shirt-India', redirect: '/men/t-shirts'},
    {path: '/product/lurch-addams-family-t-shirts-india', redirect: '/men/t-shirts'},
    {path: '/product/buddha-lol-funny-t-shirts-india', redirect: '/men/t-shirts'},
    {path: '/product/lord-of-the-rings-hobbit-t-shirt', redirect: '/men/t-shirts'},
    {path: '/product/reality-is-an-illusion-t-shirt-india', redirect: '/men/t-shirts'},
    {path: '/product/blanks-grey-melange', redirect: '/men/t-shirts'},
    {path: '/product/ultra-master-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/harry-potter-hogwarts-home-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/x-men-xaviers-school-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/captain-america-super-soldier-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/batman-i-am-the-night-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/the-flash-outrun-reality-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/batman-i-am-the-night-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/captain-america-super-soldier-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/batman-i-am-the-night-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/mystery-tshirt', redirect: '/men/t-shirts'},
    // {path: '/product/bits-its-magic-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/wwe-authentic-pete-dunne-to-the-bitter-end-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/wwe-authentic-adam-cole-bay-bay-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/wwe-authentic-the-undisputed-era-cole-fish-o-reilly-strong-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/wwe-aleister-black-fade-to-black-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/kings-xi-punjab-polo-logo-tshirt-gayle-333', redirect: '/men/t-shirts'},
    {path: '/product/kkr-vintage-logo-russell-12-tshirt', redirect: '/men/t-shirts'},
    // {path: '/product/kkr-do-the-knight-thing-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/shubham-test', redirect: '/men/t-shirts'},
    {path: '/product/kxip-gayle-storm-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/kxip-live-punjabi-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/kxip-punjabi-se-panga-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/kxip-chak-de-phatte-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/spider-man-mask-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/tmnt-no-slicce-left-behind-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/ludo-king-ludo-king-tshirt', redirect: '/men/t-shirts'},
    {path: '/product/wolverine-beast-mode-on-tshirt', redirect: '/men/t-shirts'},

    {path: '/explore/t-shirts', redirect: '/men/t-shirts'},
    {path: '/explore/drop-cut-tshirts', redirect: '/men/drop-cut-tshirts'},
    {path: '/explore/full-sleeve-tshirts', redirect: '/men/full-sleeve-tshirts'},
    {path: '/explore/polos', redirect: '/men/polo-tshirts'},
    {path: '/explore/tank-tops-and-vests', redirect: '/men/tank-tops-and-vests'},
    {path: '/explore/joggers', redirect: '/men/joggers'},
    {path: '/explore/sweatshorts', redirect: '/men/sweat-shorts'},
    {path: '/explore/boxer-shorts', redirect: '/men/boxer-shorts'},
    {path: '/explore/sweatshirts', redirect: '/men/hoodies-and-sweatshirts'},
    {path: '/explore/longline-tshirts', redirect: '/men/longline-tshirts'},
    {path: '/explore/v-neck-tshirts', redirect: '/men/v-neck-tshirts'},
    {path: '/explore/oversized-tshirts', redirect: '/men/oversized-tshirts'},
    {path: '/explore/halfsleeve-shirts', redirect: '/men/halfsleeve-shirts'},
    {path: '/explore/mandrin-collar-shirts', redirect: '/men/mandrin-collar-shirts'},
    {path: '/explore/hopper-joggers', redirect: '/men/hopper-joggers'},
    {path: '/explore/linen-pajamas', redirect: '/men/linen-pajamas'},
    {path: '/explore/chinos-shorts', redirect: '/men/chinos-shorts'},
    {path: '/explore/linen-pants', redirect: '/men/linen-pants'},
    {path: '/explore/poplin-pants', redirect: '/men/poplin-pants'},
    {path: '/explore/trunks-underwear', redirect: '/men/trunks-underwear'},
    {path: '/explore/briefs-underwear', redirect: '/men/briefs-underwear'},
    // {path: '/explore/sweatshirts', redirect: '/men/sweat-shirts'},
    {path: '/explore/sweaters', redirect: '/men/sweaters'},
    {path: '/explore/shirts', redirect: '/men/shirts'},
    {path: '/explore/unisex-t-shirts', redirect: '/women/t-shirts'},
    {path: '/explore/t-shirt-dresses', redirect: '/women/t-shirt-dresses'},
    {path: '/explore/womens-tank-tops', redirect: '/women/tank-tops'},
    {path: '/explore/unisex-hoodies', redirect: '/women/hoodies-and-sweatshirts'},
    {path: '/explore/unisex-sweatshirts', redirect: '/women/hoodies-and-sweatshirts'},
    // {path: '/explore/unisex-sweatshirts', redirect: '/women/sweatshirts'},
    {path: '/explore/womens-shorts', redirect: '/women/shorts'},
    {path: '/explore/womens-joggers', redirect: '/women/joggers'},
    {path: '/explore/unisex-knitted-sweat', redirect: '/women/sweaters'},
    {path: '/explore/polo-tshirts', redirect: '/men/polo-tshirts'},
    {path: '/explore/jackets', redirect: '/men/jackets'},
    // {path: '/explore/hoodies-and-sweatshirts', redirect: '/men/hoodies-and-sweatshirts'},
    {path: '/explore/unisex-jackets', redirect: '/women/jackets'},
    {path: '/women/unisex-jackets', redirect: '/women/jackets'},

    {path: '/explore/full-sleeve-croptops', redirect: '/women/full-sleeve-croptops'},
    {path: '/explore/women-oversized-tshirts', redirect: '/women/oversized-tshirts'},
    {path: '/explore/women-full-sleeve-tshirts', redirect: '/women/full-sleeve-tshirts'},
    {path: '/explore/women-dropcut-tshirt', redirect: '/women/dropcut-tshirt'},
    {path: '/explore/women-full-sleeve-shirts', redirect: '/women/full-sleeve-shirts'},
    {path: '/explore/women-hawaiian-shirt', redirect: '/women/hawaiian-shirt'},
    {path: '/explore/female-polo-tshirt', redirect: '/women/polo-tshirt'},
    {path: '/explore/Women-full-sleeve-tshirt-dresses', redirect: '/women/full-sleeve-tshirt-dresses'},
    {path: '/explore/women-oversized-tshirt-dresses', redirect: '/women/oversized-tshirt-dresses'},
    {path: '/explore/skater-tshirt-dresses', redirect: '/women/skater-tshirt-dresses'},
    {path: '/explore/women-hooper-joggers', redirect: '/women/hooper-joggers'},
    {path: '/explore/women-pajamas', redirect: '/women/pajamas'},
    {path: '/explore/women-hipster-underwear', redirect: '/women/hipster-underwear'},
    // hoodies redirection men
    // {path: '/men/hoodies', redirect: '/men/hoodies-and-sweatshirts'},
    // {path: '/men/sweatshirts', redirect: '/men/hoodies-and-sweatshirts'},
    {path: '/men/sweat-shirts', redirect: '/men/hoodies-and-sweatshirts'},
    {path: '/explore/sweatshirts', redirect: '/men/hoodies-and-sweatshirts'},
    {path: '/explore/hoodies', redirect: '/men/hoodies-and-sweatshirts'},
    {path: '/men/hoodies-and-jackets', redirect: '/men/hoodies-and-sweatshirts'},
    {path: '/explore/sweat-shirts', redirect: '/men/hoodies-and-sweatshirts'},
    // {path: '/explore/hoodies-and-jackets', redirect: '/men/hoodies-and-sweatshirts'},
    // hoodies redirection women
    {path: '/women/hoodies-and-jackets', redirect: '/women/hoodies-and-sweatshirts'},
    {path: '/explore/unisex-sweatshirts', redirect: '/women/hoodies-and-sweatshirts'},
    {path: '/explore/unisex-hoodies', redirect: '/women/hoodies-and-sweatshirts'},
    {path: '/explore/unisex-hoodies-and-jackets', redirect: '/women/hoodies-and-sweatshirts'},
    {path: '/explore/womens-shirts', redirect: '/women/shirts'},
    {path: '/explore/womens-pajamas', redirect: '/women/pajamas'},
    {path: '/explore/jeggings', redirect: '/women/jeggings'},
    {path: '/explore/mandrin-collared-shirts', redirect: '/men/mandrin-collared-shirts'},
    {path: '/explore/women-full-sleeve-tshirt', redirect: '/women/full-sleeve-tshirt'},
    {path: '/explore/mens-supima-collection', redirect: '/men/supima-collection'},
    {path: '/explore/womens-supima-collection', redirect: '/women/supima-collection'},
    {path: '/explore/women-full-sleeve-tshirt', redirect: '/women/full-sleeve-tshirt'},
    {path: '/explore/womens-pajamas', redirect: '/women/pajamas'},
    {path: '/explore/women-polo-tshirt', redirect: '/women/polo-tshirt'},
    {path: '/explore/Women-full-sleeve-tshirtdresses', redirect: '/women/full-sleeve-tshirt-dresses'},
    {path: '/contact-us-mobile'},
    {path: '/TSSBirthday-mobile'},
    {path: '/the-ultimate-tee-mobile'},
    {path: '/about-us-mobile'},
    {path: '/bulk-and-custom-orders-mobile'},
    {path: '/privacy-policy-mobile'},
    {path: '/terms-and-conditions-mobile'},
    {path: '/covidrelieffund-mobile'},
    {path: '/pause-for-paws-mobile'},
    {path: '/careers-mobile'},
    {path: '/explore/mens-cotton-pants', redirect: '/men/cotton-pants'},
    {path: '/explore/unisex-denim-joggers', redirect: '/women/cotton-pants'},
    {path: '/explore/men-co-ord-sets', redirect: '/men/co-ord-sets'},
    {path: '/men/printedsocks', redirect: '/men/printed-socks'},
    {path: '/men/layered-t-shirts', redirect: '/men/layered-tshirts'},
    {path: '/men/half-sleeve-henley', redirect: '/men/half-sleeve-henley-tshirts'},
    {path: '/men/mystery-t-shirts', redirect: '/men/mystery-tshirts'},
    {path: '/men/supima-full-sleeve-henleys', redirect: '/men/supima-full-sleeve-henleys-tshirts'},
    // {path: '/men/supima-t-shirts', redirect: '/men/supima-tshirts'},
    {path: '/men/supima-drop-cut-t-shirts', redirect: '/men/supima-drop-cut-tshirts'},
    {path: '/men/supima-half-sleeve-henleys', redirect: '/men/supima-half-sleeve-henley-tshirts'},
    {path: '/men/halfsleeve-shirts', redirect: '/men/half-sleeve-shirts'},
    {path: '/men/mens-supima-pants', redirect: '/men/supima-pants'},
    // New
    {path: '/women/womens-tshirts', redirect: '/women/tshirts'},
    {path: '/women/women-co-ord-sets', redirect: '/women/co-ord-sets'},
    {path: '/women/t-shirt-dresses', redirect: '/women/tshirt-dresses'},
    {path: '/women/womens-polo-tshirt', redirect: '/women/polo-tshirts'},
    {path: '/women/womens-dolman-sleeve-tshirts', redirect: '/women/dolman-sleeve-tshirts'},
    {path: '/women/womens-oversized-crop-top', redirect: '/women/oversized-crop-tops'},
    {path: '/women/womens-drop-shoulder-tshirt', redirect: '/women/drop-shoulder-tshirt'},
    {path: '/women/supima-women-t-shirts', redirect: '/women/supima-tshirts'},
    {path: '/women/womens-henley', redirect: '/women/henley-tshirts'},
    {path: '/women/women-oversized-tshirts', redirect: '/women/oversized-tshirts'},
    {path: '/women/layered-t-shirts', redirect: '/women/layered-tshirts'},
    {path: '/women/mystery-womens-t-shirts', redirect: '/women/mystery-tshirts'},
    {path: '/women/supima-t-shirts', redirect: '/women/supima-tshirts'},
    {path: '/women/Women-full-sleeve-tshirt-dressess', redirect: '/women/full-sleeve-tshirt-dresses'},
    {path: '/women/women-hawaiian-shirt', redirect: '/women/hawaiian-shirts'},
    {path: '/women/women-mandarin-shirt', redirect: '/women/mandarin-shirts'},
    {path: '/women/womens-shirt-dress', redirect: '/women/shirt-dresses'},
    {path: '/women/women-sweatshirts', redirect: '/women/sweatshirts'},
    {path: '/women/women-hoodies', redirect: '/women/hoodies'},
    {path: '/women/womens-shorts', redirect: '/women/shorts'},
    {path: '/product/friends-logo-womens-tank-top', redirect: '/'},
    {path: '/men/mandarin-shirts', redirect: '/'},
    {path: '/product/pizza-heart-womens-pajamas', redirect: '/'},
    {path: '/product/tom-and-jerry-pattern-hawaiian-shirt', redirect: '/'},
    {path: '/product/harry-potter-gryffindor-sigil-sweater', redirect: '/'},
    {path: '/men/henley-tshirts', redirect: '/'},
    {path: '/product/solids-dusty-peach-mandarin-polos', redirect: '/'},
    {path: '/product/solids-acid-wash-blue-tshirt', redirect: '/'},
    {path: '/product/solids-black-sweatshirts', redirect: '/'},
    {path: '/product/the-flash-central-city-running-club-drop-cut-tshirt', redirect: '/'},
    {path: '/product/chennai-super-kings-official-match-replica-full-sleeve-2021-dhoni-7-jersey', redirect: '/'},
    {path: '/product/coding-ninjas-placement-kit-combo-pack', redirect: '/'},
    {path: '/product/rajasthan-royals-official-polo-2021-polo', redirect: '/'},
    {path: '/product/coding-ninjas-welcome-kit-premium-combo-pack', redirect: '/'},
    {path: '/product/solids-acid-wash-black-tshirt', redirect: '/'},
    {path: '/product/mickey-mouse-classic-womens-tank-top', redirect: '/'},
    {path: '/product/looney-tunes-what-the-duck-tshirt', redirect: '/'},
    {path: '/product/wwe-aj-styles-phenomenally-done-tshirt', redirect: '/'},
    {path: '/product/friends-the-reunion-tshirt', redirect: '/'},
    {path: '/product/wwe-nxt-logo-tshirt', redirect: '/'},
    {path: '/product/deadpool-logo-men-co-ord-set', redirect: '/'},
    {path: '/product/wwe-roman-reigns-we-believe-vest', redirect: '/'},
    {path: '/product/solids-leggings-bottle-green', redirect: '/'},
    {path: '/product/friends-commando-tshirt', redirect: '/'},
    {path: '/product/wwe-raw-is-war-tshirt', redirect: '/'},
    {path: '/women/jeggings', redirect: '/'},
    {path: '/product/mustard-navy-supima-cotton-raglan-full-sleeve-tshirt', redirect: '/'},
    {path: '/product/csk-super-kings-tshirt', redirect: '/'},
    {path: '/men/hawaiian-shirts', redirect: '/'},
    {path: '/product/peanuts-already-tired-tshirt', redirect: '/'},
    {path: '/product/iron-man-the-suit-full-sleeve-tshirts', redirect: '/'},
    {path: '/product/wwe-authentic-john-cena-earn-it-tshirt', redirect: '/'},
    {path: '/product/liverpool-steven-gerrard-tshirt', redirect: '/'},
    {path: '/product/mumbai-indians-official-match-replica-2021-jersey', redirect: '/'},
    {path: '/product/wwe-authentic-cesaro-back-in-the-swing-tshirt', redirect: '/'},
    {path: '/product/wwe-the-rock-logo-performance-jersey', redirect: '/'},
    {path: '/product/minnie-mouse-pattern-womens-oversized-t-shirt', redirect: '/'},
    {path: '/product/superman-classic-logo-sweater', redirect: '/'},
    {path: '/product/good-vibes-only-mens-sweatshirt', redirect: '/'},
    {path: '/product/liverpool-fc-camo-men-coord-set', redirect: '/'},
    {path: '/product/blue-and-white-sweatshorts', redirect: '/'},
    {path: '/product/wwe-nwo-wolfpac-tshirt', redirect: '/'},
    {path: '/product/solids-snow-blue-sweatshirt', redirect: '/'},
    {path: '/product/rrr-official-mask', redirect: '/'},
    {path: '/explore/exclusive-membership', redirect: '/'},
    {path: '/exclusive', redirect: '/membership'},
    {path: '/product/coding-ninjas-welcome-kit-standard-combo-pack', redirect: '/'},
    {path: '/explore/dog-bowl', redirect: '/'},
    {path: '/men/printed-socks', redirect: '/'},
    {path: '/tags/others', redirect: '/'},
    {path: '/product/flying-pig-lapel-pin', redirect: '/'},
    {path: '/explore/samsung-a40', redirect: '/'},
    {path: '/explore/hawaiian-shirts', redirect: '/'},
    {path: '/explore/mandarin-shirts', redirect: '/'},
    {path: '/explore/henley-tshirts', redirect: '/'},
    {path: '/women/supima-collecion', redirect: '/women/womens-supima-collection'},
    {path: '/product/powerpuff-girls-the-trio-mug', redirect: '/'},
    {path: '/product/k-tshirt', redirect: '/'},
    {path: '/artists/puncch-beat', redirect: '/'},
    {path: '/product/friends-they-dont-know-tshirt', redirect: '/'},
    {path: '/product/harry-potter-hogwarts-sigil-tshirt', redirect: '/'},
    {path: '/product/the-flash-scarlet-speedster-tshirt', redirect: '/'},
    {path: '/product/batman-be-yourself-tshirt', redirect: '/'},
    {path: '/product/johnny-bravo-hunk-tshirt', redirect: '/'},
    {path: '/product/aditi-mittal-a-blah-nari-tshirt', redirect: '/'},
    {path: '/product/johnny-bravo-hunk-tshirt', redirect: '/'},
    {path: '/product/wwe-authentic-seth-rollins-burn-it-down-tshirt', redirect: '/'},
    {path: '/product/rj-roshan-full-power-tshirt', redirect: '/'},
    {path: '/product/official-wwe-the-rock-tshirt', redirect: '/'},
    {path: '/product/the-flash-point-tshirt', redirect: '/'},
    {path: '/product/looney-tunes-bugs-tshirt-dress', redirect: '/'},
    {path: '/product/looney-tunes-taz-tshirt', redirect: '/'},
    {path: '/product/deadpool-mask-backpack', redirect: '/'},
    {path: '/product/friends-doodle-new', redirect: '/'},
    {path: '/product/marvel-punisher-skull-backpack', redirect: '/'},
    {path: '/product/wonder-woman-princess-diana-tshirt', redirect: '/'},
    {path: '/product/superman-logo-tshirt', redirect: '/'},
    {path: '/product/wish-you-were-beer-tshirt', redirect: '/'},
    {path: '/product/friends-doodle-mug', redirect: '/'},
    {path: '/product/captain-america-logo-tshirt', redirect: '/'},
    {path: '/product/harry-potter-sorting-hat-tshirt', redirect: '/'},
    {path: '/product/ideas-are-bulletproof-backpack', redirect: '/'},
    {path: '/product/superheroes-trio-tshirt', redirect: '/'},
    {path: '/product/authentic-wwe-the-rock-brahma-bull-tshirt', redirect: '/'},
    {path: '/product/looney-tunes-bugs-tshirt', redirect: '/'},
    {path: '/product/joker-devils-advocate-xiaomi-redmi-note-4-mobile-cover', redirect: '/'},
    {path: '/product/its-organic-backpack', redirect: '/'},
    {path: '/product/stay-weird-tshirt', redirect: '/'},
    {path: '/product/k-backpack', redirect: '/'},
    {path: '/product/batman-be-yourself-tshirt', redirect: '/'},
    {path: '/product/harry-potter-hogwarts-sigil-tshirt', redirect: '/'},
    {path: '/product/official-wwe-the-rock-tshirt', redirect: '/'},
    {path: '/product/peanuts-my-anxieties-tshirt', redirect: '/'},
    {path: '/product/deadpool-mask-backpack', redirect: '/'},
    {path: '/product/looney-tunes-taz-tshirt', redirect: '/'},
    {path: '/explore/pins', redirect: '/'},
    {path: '/product/apun-ashwathama-hai-tshirt', redirect: '/'},
    {path: '/product/the-flash-point-tshirt', redirect: '/'},
    {path: '/product/lets-hit-the-road-backpack', redirect: '/'},
    {path: '/product/captain-america-logo-tshirt', redirect: '/'},
    {path: '/product/green-lantern-logo-tshirt', redirect: '/'},
    {path: '/product/harry-potter-doodle-mug', redirect: '/'},
    {path: '/product/looney-tunes-bugs-tshirt', redirect: '/'},
    {path: '/product/wonder-woman-fight-like-a-girl-tshirt', redirect: '/'},
    {path: '/product/looney-tunes-sylvester-tshirt', redirect: '/'},
    {path: '/product/harry-potter-platform-9-3-by-4-tshirt', redirect: '/'},
    {path: '/product/captain-america-guardian-of-freedom-tshirt', redirect: '/'},
    {path: '/product/harry-potter-hogwarts-sigil-backpack', redirect: '/'},
    {path: '/product/harry-potter-spells-backpack', redirect: '/'},
    {path: '/product/punisher-skull-glow-in-the-dark-tshirt', redirect: '/'},
    {path: '/product/marvel-punisher-skull-backpack', redirect: '/'},
    {path: '/product/scooby-doo-scooby-face-tshirt', redirect: '/'},
    {path: '/product/joker-devils-advocate-glow-in-the-dark-tshirt', redirect: '/'},
    {path: '/product/friends-chandler-bing-tshirt', redirect: '/'},
    {path: '/product/gotg-volume-2-star-lord-tshirt', redirect: '/'},
    {path: '/product/spongebob-incredibob-tshirt', redirect: '/'},
    {path: '/product/official-wwe-brock-lesnar-beast-incarnate-tshirt', redirect: '/'},
    {path: '/product/superman-son-of-krypton-tshirt', redirect: '/'},
    {path: '/product/friends-joey-tshirt', redirect: '/'},
    {path: '/product/wwe-authentic-brock-lesnar-suplex-city-welcomes-you-tshirt', redirect: '/'},
    {path: '/product/johnny-bravo-hunk-tshirt', redirect: '/'},
    {path: '/product/captain-america-costume-socks', redirect: '/'},
    {path: '/product/wonder-woman-logo-tshirt-dress', redirect: '/'},
    {path: '/product/friends-joey-tshirt', redirect: '/'},
    {path: '/product/punisher-skull-duffle-bag', redirect: '/'},
    {path: '/product/stay-weird-tshirt', redirect: '/'},
    {path: '/product/mumbai-indians-official-travel-polo-men-jersey', redirect: '/'},
    {path: '/product/punisher-skull-camo-joggers', redirect: '/men/joggers'},
    {path: '/product/looney-tunes-bugs-bunny-pattern-woven-joggers', redirect: '/women/joggers'},
    /* listing route redirect */
    {
      path: '/mobile-covers',
      name: 'mobile-covers',
      component: () => import(/* webpackChunkName: "Mobile Covers" */ '@/components/mobile-covers')
    },
    {
      path: '/search',
      name: 'search',
      component: () => import(/* webpackChunkName: "search" */ '@/components/search')
    },
    {
      path: '/about-us',
      name: 'about',
      component: function (resolve) {
        require(['@/components/about.vue'], resolve)
      }
    },
    {
      path: '/investor-relation',
      name: 'Investor-relation',
      component: function (resolve) {
        require(['@/components/investorRelation.vue'], resolve)
      }
    },
    {
      path: '/faqs',
      name: 'faqs',
      component: () => import(/* webpackChunkName: "faq" */ '@/components/faqs')
    },
    {
      path: '/sitemap',
      name: 'sitemap',
      component: () => import(/* webpackChunkName: "sitemap" */ '@/components/sitemap')
    },
    {
      path: '/nps-feedback',
      name: 'feedback',
      component: () => import(/* webpackChunkName: "feedback" */ '@/components/Feedback')
    },
    {
      path: '/privacy-policy',
      name: 'privacyPolicy',
      component: () => import(/* webpackChunkName: "privacyPolicy" */ '@/components/privacyPolicy')
    },
    {
      path: '/generate-sitemap-html',
      name: 'sitemapHTML',
      component: () => import(/* webpackChunkName: "privacyPolicy" */ '@/components/sitemapHtml')
    },
    {
      path: '/avengers-endgame-sale',
      name: 'avengersale',
      component: () => import(/* webpackChunkName: "avengerSale" */ '@/components/avengers-sale')
    },
    {
      path: '/offers',
      name: 'offers',
      component: () => import(/* webpackChunkName: "offers" */ '@/components/offers')
    },
    {
      path: '/terms-and-conditions',
      name: 'termsconditions',
      component: () => import(/* webpackChunkName: "termsConditions" */ '@/components/termsConditions')
    },
    {
      path: '/gift-voucher',
      name: 'giftvoucher',
      component: () => import(/* webpackChunkName: "giftVoucher" */ '@/components/giftvoucher')
    },
    // {
    //   path: '/souled-army',
    //   name: 'souledarmy',
    //   component: () => import(/* webpackChunkName: "souledarmy" */ '@/components/souledarmy')
    // },
    {
      path: '/schools-and-colleges',
      name: 'schoolcolleges',
      component: () => import(/* webpackChunkName: "schoolcolleges" */ '@/components/schoolcolleges')
    },
    {
      path: '/contact-us',
      name: 'contact',
      component: () => import(/* webpackChunkName: "UltimateTee" */ '@/components/contact'),
      meta: {requiresAuth: true}
    },
    {
      path: '/the-ultimate-tee',
      name: 'UltimateTee',
      component: () => import(/* webpackChunkName: "UltimateTee" */ '@/components/ultimateTee')
    },
    {
      path: '/bulk-and-custom-orders',
      name: 'bulkcustomerorder',
      beforeEnter () { location.href = 'https://bulkorders.thesouledstore.com/' }
    },
    {
      path: '/early-access',
      name: 'earlyAccess',
      component: () => import(/* webpackChunkName: "earlyAccess" */ '@/components/earlyAccess')
    },
    {
      path: '/careers',
      name: 'careers',
      component: () => import(/* webpackChunkName: "careers" */ '@/components/careers')
    },

    {
      path: '/submission-guidelines/:option',
      name: 'submissionguidelines',
      component: () => import(/* webpackChunkName: "submisionguidelines" */ '@/components/submisionguidelines')
    },
    {
      path: '/submit-art-work',
      name: 'submit-art-work',
      component: () => import(/* webpackChunkName: "submitartwork" */ '@/components/submitartwork')
    },
    {
      path: '/cart/:odid?',
      name: 'cart',
      component: () => import(/* webpackChunkName: "cart" */ '@/components/cart')
    },
    {
      path: '/shipment/:odid?',
      name: 'shipment',
      component: () => import(/* webpackChunkName: "shipment" */ '@/components/cart'),
      beforeEnter: (to, from, next) => {
        if (isSelectedCountryGlobal) {
          next({
            path: '/'
          })
        } else {
          next()
        }
      }
    },
    {
      path: '/product/:pname',
      name: 'productdetails',
      component: () => import(/* webpackChunkName: "productdetails" */ '@/components/productdetails'),
      beforeEnter: (to, from, next) => {
        store.state.tagManager.productDetailsPrevRoute = from
        next()
      }
    },
    {
      path: '/artwork-sale',
      name: 'myartworksale',
      component: () => import(/* webpackChunkName: "myartworksale" */ '@/components/my-artwork-sale'),
      meta: { requiresAuth: true }
    },
    {
      path: '/login',
      name: 'login',
      component: function (resolve) {
        require(['@/components/auth.vue'], resolve)
      }
      // meta: { requiresAuth: false }
    },
    {
      path: '/register',
      name: 'register',
      component: function (resolve) {
        require(['@/components/auth.vue'], resolve)
      }
    },
    {
      path: '/profile',
      name: 'myprofile',
      component: function (resolve) {
        require(['@/components/myprofile.vue'], resolve)
      },
      meta: {requiresAuth: true}
    },
    {
      path: '/my-gift-voucher',
      name: 'mygiftvoucher',
      component: () => import(/* webpackChunkName: "mygiftvoucher" */ '@/components/mygiftvoucher'),
      meta: {requiresAuth: true},
      beforeEnter: (to, from, next) => {
        if (isSelectedCountryGlobal) {
          next({
            path: '/'
          })
        } else {
          next()
        }
      }
    },
    {
      path: '/my-reward-points/money',
      name: 'myrewardpointsMoney',
      component: function (resolve) {
        require(['@/components/myrewardpointsMoney.vue'], resolve)
      },
      meta: {requiresAuth: true},
      beforeEnter: (to, from, next) => {
        if (isSelectedCountryGlobal) {
          next({
            path: '/'
          })
        } else {
          next()
        }
      }
    },
    {
      path: '/my-reward-points/points',
      name: 'myrewardpointsTss',
      component: function (resolve) {
        require(['@/components/myrewardpointsTss.vue'], resolve)
      },
      meta: {requiresAuth: true},
      beforeEnter: (to, from, next) => {
        if (isSelectedCountryGlobal) {
          next({
            path: '/'
          })
        } else {
          next()
        }
      }
    },
    {
      path: '/my-saved-cards',
      name: 'mySavedCards',
      component: function (resolve) {
        require(['@/components/mySavedCards.vue'], resolve)
      },
      meta: {requiresAuth: true},
      beforeEnter: (to, from, next) => {
        if (isSelectedCountryGlobal) {
          next({
            path: '/'
          })
        } else {
          next()
        }
      }
    },
    {
      path: '/order/cancel/:orderId',
      name: 'cancelorder',
      component: () => import(/* webpackChunkName: "cancelorder" */ '@/components/cancelorder'),
      meta: {requiresAuth: true}
    },
    {
      path: '/order/exchange/:orderId',
      name: 'exchangeOrder',
      component: () => import(/* webpackChunkName: "exchangeorder" */ '@/components/exchangeOrder'),
      meta: {requiresAuth: true}
    },
    {
      path: '/order/return/:orderId',
      name: 'returnOrder',
      component: () => import(/* webpackChunkName: "returnOrder" */ '@/components/return/returnOrder'),
      meta: {requiresAuth: true}
    },
    {
      path: '/order/track/:ordId/:ordtype',
      name: 'trackorder',
      component: () => import(/* webpackChunkName: "trackorder" */ '@/components/trackorder')
    },
    {
      path: '/profile-address',
      name: 'profileaddress',
      component: () => import(/* webpackChunkName: "changeAddress" */ '@/components/profileAddress')
    },
    {
      path: '/view-invoice/:oid',
      name: 'viewinvoice',
      component: () => import(/* webpackChunkName: "viewInvoice" */ '@/components/viewInvoice'),
      meta: {requiresAuth: true}
    },
    {
      path: '/orders',
      name: 'myorders',
      component: function (resolve) {
        require(['@/components/myorders.vue'], resolve)
      },
      meta: {requiresAuth: true}
    },
    {
      path: '/thank-you',
      name: 'thankyou',
      component: () => import(/* webpackChunkName: "thankyou" */ '@/components/thankyou'),
      meta: {requiresAuth: true}
    },
    {
      path: '/failure',
      name: 'failure',
      component: () => import(/* webpackChunkName: "failure" */ '@/components/failure')
    },
    {
      path: '/delivery-address',
      name: 'deliveryaddress',
      component: () => import(/* webpackChunkName: "deliveryAddress" */ '@/components/deliveryAddress'),
      meta: {requiresAuth: true}
    },
    {
      path: '/add-address',
      name: 'addAddress',
      component: () => import(/* webpackChunkName: "deliveryAddress" */ '@/components/common/editAddAddressScreen'),
      meta: {requiresAuth: true}
    },
    {
      path: '/edit-address/:addId',
      name: 'editAddress',
      component: () => import(/* webpackChunkName: "deliveryAddress" */ '@/components/common/editAddAddressScreen'),
      meta: {requiresAuth: true}
    },
    {
      path: '/checkout',
      name: 'paymentoptions',
      component: () => import(/* webpackChunkName: "paymentOptions" */ '@/components/paymentOptions'),
      props: true,
      meta: {requiresAuth: true}
    },
    {
      path: '/error',
      name: 'error',
      component: () => import(/* webpackChunkName: "error" */ '@/components/error')
    },
    {
      path: '/notfound',
      name: 'notfound',
      component: () => import(/* webpackChunkName: "notFound" */ '../components/common/NoProductsFound')
    },
    {
      path: '/rosesarered',
      name: 'rosesarered',
      component: () => import(/* webpackChunkName: "RosesAreRed" */ '@/components/RosesAreRed')
    },
    {
      path: '/rosesarered/supporters',
      name: 'rosesarered-supporters',
      component: () => import(/* webpackChunkName: "RosesAreRedSupporter" */ '@/components/RosesAreRedSupporter')
    },
    {
      path: '/rosesarered/about',
      name: 'about-rosesarered',
      component: () => import(/* webpackChunkName: "AboutRosesAreRed" */ '@/components/AboutRosesAreRed')
    },
    {
      path: '/forgotpassword',
      name: 'forgotpassword',
      component: () => import(/* webpackChunkName: "forgot-password" */ '@/components/forgotpassword')
    },
    /* {
      path: '/:type/:sid',
      name: 'listing',
      component: Listing,
      props: (route) => ({query: route.query.page})
    }, */
    {
      path: '/membership',
      name: 'exclusive',
      component: () => import(/* webpackChunkName: "Exclusive" */ '@/components/exclusive')
    },
    {
      path: '/pause-for-paws',
      name: 'pauseForPaws',
      component: () => import(/* webpackChunkName: "PauseForPaws" */ '@/components/PauseForPaws/pauseForPaws')
    },
    {
      path: '/supima-landing/:gender',
      name: 'supimaLandingPage',
      component: () => import(/* webpackChunkName: "SupimaLanding" */ '@/components/SupimaLandingPage')
    },
    {
      path: '/active-wear-landing/:gender',
      name: 'activeWearLandingPage',
      component: () => import(/* webpackChunkName: "ActiveWearLanding" */ '@/components/ActiveWearLandingPage')
    },
    {
      path: '/winter-wear-landing/:gender',
      name: 'winterWearLandingPage',
      component: () => import(/* webpackChunkName: "ActiveWearLanding" */ '@/components/winterCollection/WinterWearLandingPage')
    },
    {
      path: '/contest-terms-and-conditions',
      name: 'contest-terms-conditions',
      component: () => import(/* webpackChunkName: "contestTermsConditions" */ '@/components/common/contestTermsConditions')
    },
    {
      path: '/autocomplete',
      name: 'autocomplete',
      component: () => import(/* webpackChunkName: "autocomplete" */ '@/components/common/autocomplete')
    },
    {
      path: '/dress-for-change',
      name: 'goonj',
      component: () => import(/* webpackChunkName: "Goonj" */ '@/components/goonj')
    },
    {
      path: '/the-responsible-mask',
      name: 'responsibleMask',
      component: () => import(/* webpackChunkName: "responsibleMask" */ '@/components/responsibleMask')
    },
    {
      path: '/HardikXTeachForIndia',
      name: 'feedTheSoul',
      component: () => import(/* webpackChunkName: "feedTheSoul" */ '@/components/feedTheSoul')
    },
    {
      path: '/savetheirsouls',
      name: 'wildLifeSOS',
      component: () => import(/* webpackChunkName: "wildLifeSOS" */ '@/components/wildLifeSOS')
    },
    {
      path: '/my-account',
      name: 'myAccount',
      component: () => import(/* webpackChunkName: "MyAccount" */ '@/components/MyAccount'),
      meta: {requiresAuth: true}
    },
    {
      path: '/track-my-order',
      name: 'trackmyorders',
      component: () => import(/* webpackChunkName: "TrackMyOrder" */ '@/components/TrackMyOrder'),
      meta: {requiresAuth: true}
    },
    {
      path: '/daily-drop',
      name: 'dailyDrop',
      component: () => import(/* webpackChunkName: "DailyDrop" */ '@/components/dailyDrop')
    },
    {
      path: '/from-the-soul',
      name: 'campaignTSS',
      component: () => import(/* webpackChunkName: "CampaignUI" */ '@/components/campaignUI/campaignui')
    },
    {
      path: '/winterwear-collection',
      name: 'WinterCollectionHome',
      component: () => import(/* webpackChunkName: "CatCollectionHome" */ '@/components/SummerCollection/SummerCollectionHome')
    },
    {
      path: '/men-winterwear',
      name: 'WinterCollectionPage',
      component: () => import(/* webpackChunkName: "CatCollectionPage" */ '@/components/SummerCollection/SummerCollectionPage')
    },
    {
      path: '/verify-email',
      name: 'verifyEmail',
      component: () => import(/* webpackChunkName: "verifyEmail" */ '@/components/verifyEmail')
    },
    {
      path: '/filter-landing/:slug',
      name: 'filterlanding',
      component: () => import(/* webpackChunkName: "productdetails" */ '@/components/filterlanding')
    },
    {
      path: '/women-winterwear',
      name: 'WinterCollectionPage',
      component: () => import(/* webpackChunkName: "CatCollectionPage" */ '@/components/SummerCollection/SummerCollectionPage')
    },
    {
      path: '/stay-at-home',
      name: 'StayAtHomeLandingPage',
      component: () => import(/* webpackChunkName: "StayAtHome" */ '@/components/StayAtHomeLandingPage')
    },
    {
      path: '/TSSBirthday',
      name: 'birthday',
      component: () => import(/* webpackChunkName: "birthday" */ '@/components/birthday')
    },
    {
      path: '/mywishlist',
      name: 'mywishlist',
      component: () => import(/* webpackChunkName: "Wishlist" */ '@/components/mywishlist')
    },
    {
      path: '/care-page/sneaker_page',
      name: 'sneakercare',
      component: () => import(/* webpackChunkName: "Sneakercare" */ '@/components/sneakercarehome')
    },
    {
      path: '/care-detail-page/sneaker_page/:id',
      name: 'sneakercaredetail',
      component: () => import(/* webpackChunkName: "Sneakercare" */ '@/components/sneakercaredetail')
    },
    {
      path: '/shop-the-look',
      name: 'shopTheLook',
      component: () => import(/* webpackChunkName: "ShopTheLook" */ '@/components/ShopTheLook')
    },
    {
      path: '/email-shop-now',
      name: 'emailShopNowRedirection',
      component: () => import(/* webpackChunkName: "emailShopNowRedirection" */ '@/components/emailShopNowRedirection.vue')
    },
    {
      path: '/wwe',
      beforeEnter () { location.href = '/' },
      name: 'wwe'
    },
    {
      path: '/metaverse',
      name: 'metaverseLanding',
      component: () => import(/* webpackChunkName: "metaverseLanding" */ '@/components/metaverse/metaverseLanding.vue')
    },
    {
      path: '/categories',
      name: 'categories',
      component: () => import(/* webpackChunkName: "categories" */ '@/components/categories')
    },
    {
      path: '/codcheckout',
      name: 'codcheckout',
      component: () => import(/* webpackChunkName: "codCheckout" */ '@/components/codCheckout.vue')
    },
    {
      path: '*',
      component: () => import(/* webpackChunkName: "noProductFound" */ '../components/common/NoProductsFound')
    },
    {
      path: '/:type/:sid',
      name: 'listing',
      component: Listing,
      props: (route) => ({query: route.query.page})
    },
    {
      path: '/:sid',
      name: 'listing',
      component: Listing,
      props: (route) => ({query: route.query.page})
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (to.hash) {
      // If the route has a hash (sectional link), scroll to the element with the corresponding ID.
      return {
        selector: to.hash,
        offset: { x: 0, y: 100 } // Adjust the offset as needed to accommodate any fixed headers or margins.
      }
    } else if (from.path === to.path && to.name === 'listing') {
      return {}
    }
    return {x: 0, y: 0}
  }
})

router.beforeEach((to, from, next) => {
  // const currentHostname = window.location.hostname
  if (to.path === '/pos/login/' && to.query.api_key === process.env.POS_LOGIN_API_KEY && to.query.token) {
    Vue.ls.set('tss_token', to.query.token)
    Vue.ls.set('pos_login', true)
    Vue.ls.set('pos_store_id', to.query.pos_store_id)
    Vue.ls.set('pos_user_id', to.query.pos_user_id)
    next({
      path: '/'
    })
  }
  if (to.path === '/codcheckout' && to.query.token) {
    Vue.ls.set('tss_token', to.query.token)
    Vue.ls.set('cod_checkout_login', true)
  }
  if ((from.name === 'listing' && to.name === 'listing') || (from.name === 'search' && to.name === 'search')) {
    Vue.ls.set('routeObj', {
      current: getLastPage(to.name),
      previous: Vue.ls.get('routeObj').previous || ''
    })
  } else if (to.name === 'cancelorder') {
    Vue.ls.set('routeObj', {
      current: Vue.ls.get('routeObj').current,
      previous: Vue.ls.get('routeObj').previous || ''
    })
  } else if (to.name === 'order') {
    Vue.ls.set('routeObj', {
      current: Vue.ls.get('routeObj').current,
      previous: Vue.ls.get('routeObj').previous || ''
    })
  } else {
    Vue.ls.set('routeObj', {
      current: getLastPage(to.name),
      previous: getLastPage(from.name) || ''
    })
  }
  const Datetiming = new Date()
  store && store.getters && store.getters.userInterestTime ? '' : store.commit('USER_INTEREST_TIME', Datetiming.getTime())
  if (to.path === '/login') {
    store.dispatch('CHECK_AUTH')
    if (store.getters.authStatus) {
      next({
        path: '/'
      })
    } else {
      next()
    }
  } else if (from.path === '/thank-you' && to.path === '/checkout') {
    next({
      path: '/'
    })
  } else if (to.path && to.path.includes('/tags/') && nginxTags && !nginxTags.includes(to.path) && to.params && to.params.sid) {
    if (to.query) {
      let params
      params = to.query
      next({
        path: `/${to.params.sid}`, query: params
      })
    } else {
      next({
        path: `/${to.params.sid}`
      })
    }
  } else if (to.matched.some(record => record.meta.requiresAuth)) {
    store.dispatch('CHECK_AUTH')
    if (!store.getters.authStatus) {
      next({
        path: '/login',
        query: {redirect: to.fullPath}
      })
    } else {
      next()
    }
  } else if (to.path && to.path.includes('///')) {
    next({
      path: '/notfound'
    })
  } else {
    next() // make sure to always call next()!
  }
})

router.afterEach((to, from) => {
  Vue.nextTick(() => {
    if (to.fullPath !== from.fullPath) {
      setTimeout(() => {
        store.commit('GTM_EVENT', {
          eventName: 'page_view_new',
          payload: {
            page_title: document.title,
            page_location: window.location.href,
            page_path: window.location.pathname
          }}
        )
      }, 2000)
    }
  })
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js